var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('base-material-alert',{class:{
    'secondary--text': !_vm.$vuetify.theme.dark,
    'white--text': _vm.$vuetify.theme.dark,
  },attrs:{"id":"api-error-alert","color":_vm.$vuetify.theme.dark ? 'softBackgroundRed' : 'softError'}},[(_vm.error)?_c('span',[_vm._v(" "+_vm._s(_vm.$t(("apiErrors." + _vm.error)))+" ")]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }